import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { SnackService } from '@shared/services/snack.service';
import { ApiService } from '@shared/services/api.service';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NumbersService } from '@shared/services/numbers.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { HttpClient } from '@angular/common/http';
import { User } from '@core/models';
@Component({
	selector: 'app-user-profile-change-phone',
	templateUrl: './user-profile-change-phone.component.html',
	styleUrls: ['./user-profile-change-phone.component.scss'],
})
export class UserProfileChangePhoneComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public auth: AuthService,
		private snack: SnackService,
		public api: ApiService,
		private title: Title,
		private numbers: NumbersService,
		public locale: LocaleService,
		private httpClient: HttpClient,
		public cdf: ChangeDetectorRef
	) {}
	public recaptchaVerifier: firebase.auth.RecaptchaVerifier;
	recaptchaWidgetId: number;
	visible: boolean = true;
	loading: boolean = false;
	body: any;
	user: User = this.auth.user();
	showResendOTP: boolean = false;
	showResendOTPTimer: number;
	otp: any;
	data: any;
	canExit: boolean = false;
	confirmationResult: firebase.auth.ConfirmationResult;
	filterselectedCountryPrefix: any = [];
	selectedCountryPrefix: any = [];
	currentPhonePrefix: string;

	form: FormGroup = new FormGroup({
		phonePrefix: new FormControl(localStorage.getItem('prefix'), Validators.required),
		altPhone: new FormControl('', Validators.required),
	});

	otpForm: FormGroup = new FormGroup({
		otp: new FormControl('', Validators.required),
	});

	setTimeoutResendOTP() {
		setTimeout(() => {
			this.showResendOTP = true;
		}, 60000);

		this.showResendOTPTimer = 60;
		let timer = setInterval(() => {
			this.showResendOTPTimer = this.showResendOTPTimer - 1;

			if (this.showResendOTPTimer === 0) {
				this.showResendOTP = true;

				this.showResendOTPTimer = undefined;
				clearInterval(timer);
			}
		}, 1000);
	}

	resendOTP(showSnack: boolean = true) {
		this.showResendOTP = false;
		this.loading = true;
		this.sendOtp();
	}

	onSelect(id: string) {
		this.currentPhonePrefix = id;
		//localStorage.setItem('prefix', id);
	}

	onKey(value) {
		value == '' ? (this.filterselectedCountryPrefix = this.selectedCountryPrefix) : (this.filterselectedCountryPrefix = this.search(value));
	}

	search(value: string) {
		let filter = value.toLowerCase();
		return this.selectedCountryPrefix.filter((option) => option.name.toLowerCase().includes(filter));
	}

	onKeyUp(field: string) {
		this.form.get(field).setValue(this.numbers.toNumeric(this.form.get(field).value.toString().replace(/\s/g, '')));

		if (this.form.get(field).value.toString().charAt(1) === '0') {
			this.form.get(field).setValue(this.form.get(field).value.toString().slice(0, 1) + this.form.get(field).value.toString().slice(2));
		}

		if (this.form.get(field).value.toString().charAt(0) !== '0') {
			this.form.get(field).setValue('0' + this.form.get(field).value.toString());
		}
	}

	//fctn to enter only digits
	isNumberKey(evt) {
		let charCode = evt.which ? evt.which : evt.keyCode;

		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			//this.invalidMobile = false;
			return false;
		}

		return true;
	}

	fire() {
		this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
			size: 'invisible',
		});

		this.data = this.body.phone;
		this.sendOtp();
	}

	sendOtp() {
		this.loading = true;
		firebase
			.auth()
			.signInWithPhoneNumber(localStorage.getItem('prefix') + this.data.toString(), this.recaptchaVerifier)
			.then((confirmationResult) => {
				this.canExit = true;
				this.confirmationResult = confirmationResult;

				this.setTimeoutResendOTP();
			})
			.catch((err) => {
				this.loading = false;
				this.canExit = true;
				if (err['code'] == 'auth/too-many-requests') {
					this.snack.open(this.locale.translations['user']['user-verify']['n270']);
				} else if (err['code'] == 'auth/invalid-phone-number') {
					this.snack.open(this.locale.translations['logup']['signup']['n231']);
				} else {
					this.snack.open(this.locale.translations['misc']['n174']);
				}
			});
	}

	onSubmit() {
		this.loading = true;
		localStorage.setItem('prefix', this.currentPhonePrefix);
		//localStorage.setItem('prefix', this.form.controls['phonePrefix'].value);
		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('phone', this.form.controls['altPhone'].value);

		this.api.PhoneRegistered(formData).subscribe((res) => {
			if (res['response']['phoneRegistered'] === '1') {
				this.snack.open(this.locale.translations['user']['user-process']['s23']);
				this.loading = false;
			} else {
				this.visible = false;

				this.auth.user()['phone'] = this.form.controls['altPhone'].value;
				this.body = this.auth.user();

				this.body.phone = this.form.controls['altPhone'].value;
				this.loading = false;
				this.cdf.detectChanges();
				this.fire();
			}
		});
	}

	onUpdate() {
		this.loading = true;
		const dataaaa = this.otp;
		this.confirmationResult
			.confirm(dataaaa)
			.then((user) => {
				localStorage.setItem('user', JSON.stringify(this.body));

				const newUser: any = [];
				newUser.push(user);

				const formData: FormData = new FormData();
				formData.append('lang', this.locale.lang);
				formData.append('userID', this.user['userID']);
				// formData.append('password', this.form.get('password').value);

				formData.append('altPhone', this.form.controls['altPhone'].value);
				formData.append('firebaseID', newUser[0].user.uid);

				this.body.phone = this.form.controls['altPhone'].value;
				this.api.updatePhone(formData).subscribe((res) => {
					if (res['status'] === '1') {
						this.body = this.auth.user();

						this.loading = false;
						this.snack.open(this.locale.translations['user']['user-profile']['change-phone']['n288']);
						this.router.navigate(['/']);
					} else {
						this.snack.open(res['message']);
						this.loading = false;
					}
				});
			})
			.catch((err) => {
				this.snack.open(this.locale.translations['user']['user-verify']['n238']);

				this.loading = false;
			});
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['user']['user-profile']['n244'] + ' | ' + this.locale.translations['header']['n0']);
		this.currentPhonePrefix = localStorage.getItem('prefix');

		this.httpClient.get<any>('./assets/country_dial_info.json').subscribe((data) => {
			this.selectedCountryPrefix = data;
			this.filterselectedCountryPrefix = data;
		});
	}
}
